export const VNTRANSACTIONS_SET_CARD_DATA = 'VNTRANSACTIONS_SET_CARD_DATA'
export const VNTRANSACTIONS_CLEAR_CARD_DATA = 'VNTRANSACTIONS_CLEAR_CARD_DATA'
export const VNTRANSACTIONS_SET_ORDER_DATA = 'VNTRANSACTIONS_SET_ORDER_DATA'
